import React from 'react';
import logo from '../assets/logo.png';
import { Button } from '@heroui/react';
import { useTheme } from '../hooks/useTheme';

const Header = ({ onOpenWelcomeModal }) => {
  const { theme, toggleTheme } = useTheme();
  return (
    <header className="py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <img 
              src={logo} 
              alt="Finalism" 
              className="h-16" 
            />
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={toggleTheme}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
              className="inline-flex items-center justify-center w-9 h-9 rounded-md hover:bg-gray-50 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-200"
              title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
            >
              {theme === 'dark' ? (
                // Sun icon for light mode target
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="4" />
                  <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41" />
                </svg>
              ) : (
                // Moon icon for dark mode target
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              )}
            </button>
          <Button
            variant="light"
            onPress={onOpenWelcomeModal}
            className="text-primary hover:text-primary-hover text-sm flex items-center px-3 py-1.5 rounded-md hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors"
          >
            <svg 
              className="w-4 h-4 mr-1.5" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="17" x2="12" y2="17"></line>
            </svg>
            How It Works
          </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;